<template>
  <div class="menuNotification__content d-flex align-center">
    <div class="d-flex align-center">
      <NotifiersAvatar
        :notifiers="item.notifiers"
        :status="item.status"
      />
      <v-list-item-content>
        <span>
          <span @click.stop="linkToPage('user')"
            class="font-weight-bold menuNotification__title"
          >
          {{ (item.notifiers.length > 1 && item.type === NOTIFIER_FOLLOW) ?
            `${item.notifiers[0].name}, ${item.notifiers[1].name}` :
            item.notifiers[0].name
          }}
          </span>
          {{showText(item)}}
          <span
            v-if="item.entityName === 'course'"
            class="primary--text text-capitalize"
            text
            plain
            @click.stop="linkToPage('course')"
          >{{`@${item.entityDetail.name}`}}</span>
          <span
            v-else-if="item.entityName !== 'post' &&
              item.type !== NOTIFY_GOLF_REQUEST &&
              item.type !== NOTIFIER_FRIEND_REQUEST &&
              item.type !== NOTIFY_COMMENT &&
              item.type !== NOTIFY_REPLY_COMMENT &&
              item.type !== NOTIFY_NEW_MESSAGE">
            {{(item.entityDetail && item.entityDetail.name)}}
          </span>
        </span>
        <span class="menuNotification__dateAgo font-weight-bold">{{ item.createdDate | ago }}</span>
      </v-list-item-content>
    </div>
    <div class="mr-1 mt-1 btnUnread" v-if="status === NOTIFY_UNREAD && $vuetify.breakpoint.lg" >
      <v-icon size="12" color="primary">fas fa-circle</v-icon>
    </div>
    <v-btn icon color="red" :class="$vuetify.breakpoint.lg ? 'btnDelete' : ''" @click.stop="deleteNotify()">
      <v-icon class="fal fa-xmark"></v-icon>
    </v-btn>
  </div>
</template>

<script>
import NotifiersAvatar from "@/components/Notification/NotifiersAvatar";
import NotificationService from '@/services/NotificationService';
export default {
  name: "NotifyItem",
  components: {NotifiersAvatar},
  props: {
    item: {type: Object, default: {}},
    status: {}
  },
  methods: {
    showText(item) {
      let text = ''
      switch (item.type) {
        case NOTIFY_NEW_POST:
          text = this.$gettext('creates new post')
          break;
        case NOTIFY_GOLF_REQUEST:
          text = this.$gettext('sent you a goft request')
          break;
        case NOTIFIER_REPLY:
          text = this.$gettext('mentioned you in a discussion')
          break;
        case NOTIFIER_FOLLOW:
          if(item.entityName == 'course') {
            if(item.notifiers.length > 2) {
              text = this.$gettextInterpolate(this.$gettext('and %{number} others follow'), {number: item.notifiers.length - 2})
            } else {
              text = this.$gettext('started following')
            }
          } else {
            if(item.notifiers.length > 2) {
              text = this.$gettextInterpolate(this.$gettext('and %{number} others follow you'), {number: item.notifiers.length - 2})
            } else {
              text = this.$gettext('started following you')
            }
          }
          break;
        case NOTIFIER_FRIEND_REQUEST:
          text = this.$gettext('send you a request')
          break;
        case NOTIFY_NEW_MESSAGE:
          text = this.$gettext('sent you a new message')
          break;
        case NOTIFY_COMMENT:
          text = this.$gettext('comments on your post')
          break;
        case NOTIFY_REPLY_COMMENT:
          text = this.$gettext('replies your comment')
          break;
      }
      return text
    },
    async read() {
      const response = await NotificationService.readNotify(this.item.id)
      if(response.error) {
        this.$toast.alert(result.error.message);
      } else {
        this.$emit('handleRead', this.item)
      }
    },
    async linkToPage(type) {
      this.$emit('closeMenu')
      await this.read()
      if(type === 'course') {
        this.$router.push({ name: 'courses.home',
          params: {coursesCountry: this.item.entityDetail.country.slug, namegolf: this.item.entityDetail.slug}
        })
      } else {
        this.$router.push({ name: 'profilePerson', params: {key: this.item.notifiers[0].id} })
      }
      this.$emit('reloadListNotify')
    },
    async deleteNotify() {
      const result = await NotificationService.deleteNotify(this.item.id);
      if(result.result === 'success') {
        this.$emit('handleDelete', this.item.id)
        if(this.item.status === NOTIFY_UNREAD){
          this.$emit('degreeTotalUnread')
        }
      }
    }
  }
};
</script>
